<div class="row center-block text-center">
    <pagination-template
      #p="paginationApi"
      [id]="config.id"
      (pageChange)="config.currentPage = $event"
    >
      <div class="custom-pagination">
        <div
          *ngIf="!p.isFirstPage()"
          class="pagination-previous"
          (click)="p.previous()"
        >
        
        <i class="glyphicon glyphicon-chevron-left"></i>
        </div>
       
        <div
          class="page-number"
          *ngFor="let page of p.pages"
          [class.current]="p.getCurrent() === page.value"
        >
          <span
            (click)="p.setCurrent(page.value)"
            *ngIf="p.getCurrent() !== page.value"
            >{{ page.label }}</span
          >
          <div *ngIf="p.getCurrent() === page.value">
            <span>{{ page.label }}</span>
          </div>
        </div>
       
        <div
          class="pagination-next"
          *ngIf="!p.isLastPage()"
          (click)="p.next()"
        > 
          <i class="glyphicon glyphicon-chevron-right"></i>
        </div>
      </div>
    </pagination-template>
  </div>